import { render, staticRenderFns } from "./ActionBox.vue?vue&type=template&id=20b90add&scoped=true&"
import script from "./ActionBox.vue?vue&type=script&lang=js&"
export * from "./ActionBox.vue?vue&type=script&lang=js&"
import style0 from "./ActionBox.vue?vue&type=style&index=0&id=20b90add&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b90add",
  null
  
)

export default component.exports